import { Box, Typography } from "@mui/material";
import { CURRENT_VERSION } from "../../../../constants/version";
import "./index.scss";

const Footer = () => {
  return (
    <Box className="dashboard-footer">
      <Box className="dashboard-footer__container">
        <Typography variant="body2" className="dashboard-footer__company">
          ACROSS ASSIST PVT LTD Copyright © 2025
        </Typography>

        <Typography variant="body2" className="dashboard-footer__text">
          {CURRENT_VERSION}
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
